var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProgramFesta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_22403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 36.457L0 18.457L18 0.457031L36 18.457L18 36.457ZM6.36114 18.457L18 30.0959L29.6389 18.457L18 6.81817L6.36114 18.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 26.0331L10.4238 18.457L17.9999 10.8809L25.576 18.457L17.9999 26.0331ZM16.785 18.457L17.9999 19.6719L19.2149 18.457L17.9999 17.242L16.785 18.457Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_22403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0 0.457031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProgramFesta);
export default __webpack_public_path__ + "static/media/icProgramFesta.c7e2d19a6dcaf2799b8f0bec4cd15a9d.svg";
export { ForwardRef as ReactComponent };